module.exports = __webpack_public_path__ + "img/Icon_Finish.2cb32e04.png";